import { v4 as uuid } from 'uuid';

//MIDDLEWARE
export const localStorageMiddleware = ({ getState }) => {
  return next => action => {
    const result = next(action);
    localStorage.setItem('applicationState', JSON.stringify(getState()));
    return result;
  };
};

export const reHydrateStore = () => {
  if (localStorage.getItem('applicationState') !== null) {
    var d = JSON.parse(localStorage.getItem('applicationState'));
    if (d.formData.allProducts.loaded) {
      d.formData.allProducts.loaded = false;
    }

    return d; // re-hydrate the store
  }
};
